// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3TylH","col":"styles_col___qOpO","fulfillmentStatus":"styles_fulfillmentStatus__2FZSg","emailCol":"styles_emailCol__NxwzE"};